webpackJsonp([21],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MS_COMPANY_CODE; });
/* unused harmony export MS_AUTHORITY_PREFIX */
/* unused harmony export MR_AUTHORITY_PREFIX */
/* unused harmony export AUTHORITY_HEADQUARTERS */
/* unused harmony export AUTHORITY_HEAD_OF_SALES_DEPARTMENT */
/* unused harmony export AUTHORITY_HEAD_OF_BRANCH */
/* unused harmony export AUTHORITY_HEAD_OF_DEPARTMENT */
/* unused harmony export AUTHORITY_SM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MS_AUTHORITY_HEADQUARTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MS_AUTHORITY_HEAD_OF_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MS_AUTHORITY_HEAD_OF_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MS_AUTHORITY_SM; });
/* unused harmony export MR_AUTHORITY_HEADQUARTERS */
/* unused harmony export MR_AUTHORITY_HEAD_OF_SALES_DEPARTMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MR_AUTHORITY_HEAD_OF_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MR_AUTHORITY_HEAD_OF_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MR_AUTHORITY_SM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAN_APPLY_FINEPLAY_AUTHORITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CAN_APPROVE_FINEPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CAN_SHOW_SURVEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CAN_SHOW_TOGGLE_INSTITUTIONS; });
/* eslint-disable */
var MS_COMPANY_CODE = 'VN';
var MS_AUTHORITY_PREFIX = 'V';
var MR_AUTHORITY_PREFIX = '';

var AUTHORITY_HEADQUARTERS = 'HO';
var AUTHORITY_HEAD_OF_SALES_DEPARTMENT = 'BM';
var AUTHORITY_HEAD_OF_BRANCH = 'DM';
var AUTHORITY_HEAD_OF_DEPARTMENT = 'TL';
var AUTHORITY_SM = 'MR';

var MS_AUTHORITY_HEADQUARTERS = MS_AUTHORITY_PREFIX + 'HO';
var MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT = MS_AUTHORITY_PREFIX + 'BM';
var MS_AUTHORITY_HEAD_OF_BRANCH = MS_AUTHORITY_PREFIX + 'DM';
var MS_AUTHORITY_HEAD_OF_DEPARTMENT = MS_AUTHORITY_PREFIX + 'SM';
var MS_AUTHORITY_SM = MS_AUTHORITY_PREFIX + 'SL';

var MR_AUTHORITY_HEADQUARTERS = 'HO';
var MR_AUTHORITY_HEAD_OF_SALES_DEPARTMENT = 'BM';
var MR_AUTHORITY_HEAD_OF_BRANCH = 'DM';
var MR_AUTHORITY_HEAD_OF_DEPARTMENT = 'TL';
var MR_AUTHORITY_SM = 'MR';

var CAN_APPLY_FINEPLAY_AUTHORITIES = [MS_AUTHORITY_HEAD_OF_BRANCH, MS_AUTHORITY_HEAD_OF_DEPARTMENT];

var CAN_APPROVE_FINEPLAY = [MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT, MS_AUTHORITY_HEAD_OF_BRANCH];

var CAN_SHOW_SURVEY = [MR_AUTHORITY_HEAD_OF_BRANCH, MR_AUTHORITY_HEAD_OF_DEPARTMENT, MR_AUTHORITY_SM];

var CAN_SHOW_TOGGLE_INSTITUTIONS = [MS_AUTHORITY_HEAD_OF_DEPARTMENT, MS_AUTHORITY_HEAD_OF_BRANCH, MR_AUTHORITY_HEAD_OF_DEPARTMENT, MR_AUTHORITY_HEAD_OF_BRANCH];

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'questionnaires';

var get = function get(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('' + resource, { params: params });
};
var submit = function submit(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/submit', data);
};
var show = function show(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/' + id);
};
var count = function count() {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/count');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  submit: submit,
  show: show,
  count: count
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navigator__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_init__ = __webpack_require__(370);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Navigator: __WEBPACK_IMPORTED_MODULE_0__components_navigator__["a" /* default */],
    Init: __WEBPACK_IMPORTED_MODULE_1__components_init__["a" /* default */]
  },
  computed: {
    env: function env() {
      return "production";
    }
  },
  mounted: function mounted() {
    if (this.env === 'staging') {
      document.title = 'FINEテスト環境';
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(108);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showMenu: false,
      auth: this.$auth.watch.data,
      MS_AUTHORITY_SM: __WEBPACK_IMPORTED_MODULE_2__config__["l" /* MS_AUTHORITY_SM */],
      MR_AUTHORITY_SM: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* MR_AUTHORITY_SM */],
      CAN_APPLY_FINEPLAY_AUTHORITIES: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* CAN_APPLY_FINEPLAY_AUTHORITIES */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    links: 'navigator/links',
    title: 'navigator/title',
    fineplay: 'navigator/fineplay',
    numberUnReadFineplayApprove: 'masterData/numberUnReadFineplayApprove',
    numberSurveyNotComplete: 'masterData/numberSurveyNotComplete'
  }), {
    canApproveFinePlay: function canApproveFinePlay() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["b" /* CAN_APPROVE_FINEPLAY */].indexOf(this.$auth.user().authority) !== -1;
    },
    canShowSurvey: function canShowSurvey() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["c" /* CAN_SHOW_SURVEY */].indexOf(this.$auth.user().authority) !== -1;
    }
  }),
  watch: {
    '$route': function $route() {
      this.showMenu = false;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    toogleFineplayScreenChat: 'navigator/toogleFineplayScreenChat'
  }), {
    goTo: function goTo(name) {
      this.showMenu = false;
      this.$router.push({ name: name });
    },
    toggleMenu: function toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout: function logout() {
      this.$loading.show();
      this.$auth.logout();
      window.location.reload();
    },
    handleToggleFineplayScreenChat: function handleToggleFineplayScreenChat() {
      this.toogleFineplayScreenChat();
    },
    canApplyFinePlay: function canApplyFinePlay() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* CAN_APPLY_FINEPLAY_AUTHORITIES */].indexOf(this.$auth.user().authority) !== -1;
    }
  }),
  mounted: function mounted() {}
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(108);



//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getNGWords: 'masterData/getNGWords',
    getNumberUnReadApprove: 'masterData/getUnreadFineplayApprove',
    addNGWord: 'masterData/addNGWord',
    updateNGWord: 'masterData/updateNGWord',
    deleteNGWord: 'masterData/deleteNGWord',
    getNumberSurveyNotComplete: 'masterData/getNumberSurveyNotComplete'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    notifications: 'masterData/notifications'
  }), {
    canShowSurvey: function canShowSurvey() {
      return __WEBPACK_IMPORTED_MODULE_5__config__["c" /* CAN_SHOW_SURVEY */].indexOf(this.$auth.user().authority) !== -1;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var newItem, ngWordRef;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getNGWords();
              _this.getNumberUnReadApprove();
              setTimeout(function () {
                if (_this.$auth.user().is_maker && _this.canShowSurvey) {
                  _this.getNumberSurveyNotComplete();
                }
              }, 1000);
              newItem = false;
              ngWordRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].ref('ngWord');

              ngWordRef.off();
              ngWordRef.on('child_added', function (data) {
                if (!newItem) return;
                _this.addNGWord(data.val());
              });
              ngWordRef.once('value', function () {
                newItem = true;
              });
              ngWordRef.on('child_changed', function (data) {
                _this.updateNGWord(data.val());
              });
              ngWordRef.on('child_removed', function (data) {
                _this.deleteNGWord(data.val());
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_NAVIGATOR_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_NAVIGATOR_LINKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_STATUS_FINEPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOOGLE_FINEPLAY_SCREEN_CHAT; });
var SET_NAVIGATOR_TITLE = 'SET_NAVIGATOR_TITLE';
var SET_NAVIGATOR_LINKS = 'SET_NAVIGATOR_LINKS';
var SET_STATUS_FINEPLAY = 'SET_STATUS_FINEPLAY';
var TOOGLE_FINEPLAY_SCREEN_CHAT = 'TOOGLE_FINEPLAY_SCREEN_CHAT';

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_INSTITUTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_INSTITUTIONS_META; });
/* unused harmony export SET_PARTICIPATE_CHAT_GROUPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_GROUP_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_UNREAD_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CURRENT_POST; });
var SET_INSTITUTIONS = 'SET_INSTITUTIONS';
var SET_INSTITUTIONS_META = 'SET_INSTITUTIONS_META';
var SET_PARTICIPATE_CHAT_GROUPS = 'SET_PARTICIPATE_CHAT_GROUPS';
var SET_GROUPS = 'SET_GROUPS';
var SET_GROUP_SELECTED = 'SET_GROUP_SELECTED';
var CLEAR_UNREAD_MESSAGES = 'CLEAR_UNREAD_MESSAGES';
var SET_CURRENT_POST = 'SET_CURRENT_POST';

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_NG_WORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_UNREAD_FINEPLAY_APPROVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NGWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_NGWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_NGWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TOTAL_NOT_COMPLETE_SURVEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_SURVEY; });
var SET_NG_WORDS = 'SET_NG_WORDS';
var SET_UNREAD_FINEPLAY_APPROVE = 'SET_UNREAD_FINEPLAY_APPROVE';
var SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
var ADD_NGWORD = 'ADD_NGWORD';
var UPDATE_NGWORD = 'UPDATE_NGWORD';
var DELETE_NGWORD = 'DELETE_NGWORD';
var SET_TOTAL_NOT_COMPLETE_SURVEY = 'SET_TOTAL_NOT_COMPLETE_SURVEY';
var COMPLETE_SURVEY = 'COMPLETE_SURVEY';

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SURVEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_SURVEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_IS_SHOW_SURVEYS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE; });
var SET_SURVEYS = 'SET_SURVEYS';
var DELETE_SURVEY = 'DELETE_SURVEY';
var SET_IS_SHOW_SURVEYS_MODAL = 'SET_IS_SHOW_SURVEYS_MODAL';
var SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE = 'SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE';

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'fine-play-groups';
var get = function get(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('' + resource, { params: params });
};
var show = function show(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/' + id);
};
var approve = function approve(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/' + id + '/approve');
};
var denial = function denial(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/' + id + '/denial');
};
var store = function store(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post('fine-plays', data);
};
var count = function count() {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/count');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  show: show,
  approve: approve,
  denial: denial,
  store: store,
  count: count
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: "AIzaSyC1-e7PSsXwzPqZ8CMmx2ziI25YEjQyKzE",
  authDomain: "mythos-sns-prod.firebaseapp.com",
  databaseURL: "https://mythos-sns-prod.firebaseio.com",
  projectId: "mythos-sns-prod",
  storageBucket: "mythos-sns-prod.appspot.com",
  messagingSenderId: "775628931095"
});

var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();

var storeChatGroup = function storeChatGroup(chatGroupId, chatGroup) {
  return db.ref('chat_groups/' + chatGroupId + '/').set(chatGroup);
};
var getChatGroup = function getChatGroup(chatGroupId) {
  return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('chat_groups/' + chatGroupId).once('value');
};
var storeEmployeeChatGroup = function storeEmployeeChatGroup(chatGroupId, employeeCode, employeeChatGroup) {
  return db.ref('chat_groups/' + chatGroupId + '/employees/' + employeeCode).set(employeeChatGroup);
};
var getInstitution = function getInstitution(institutionCode) {
  return db.ref('institutions/' + institutionCode).once('value');
};
var storeInstitution = function storeInstitution(institutionCode, institution) {
  return db.ref('institutions/' + institutionCode + '/').set(institution);
};

var storeMessage = function storeMessage(chatGroupId, messageId, message) {
  return db.ref('messages/' + chatGroupId + '/' + messageId).set(message);
};
var updateMessage = function updateMessage(chatGroupId, messageId, message) {
  return db.ref('messages/' + chatGroupId + '/' + messageId).update(message);
};
var deleteMessage = function deleteMessage(chatGroupId, messageId) {
  return db.ref('messages/' + chatGroupId + '/' + messageId).remove();
};

var updateMessageChatGroup = function updateMessageChatGroup(chatGroupId, total_messages_chat_group) {
  return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('chat_groups/' + chatGroupId + '/total').transaction(function (currentTotal) {
    // If node/clicks has never been set, currentRank will be `null`.
    if (currentTotal) return currentTotal + 1;else return total_messages_chat_group;
  });
};

var updateMessageInstitutions = function updateMessageInstitutions(institutionCode, total_messages_chat_group, company_code) {
  return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('institutions/' + institutionCode + '/total_messages/' + company_code).transaction(function (currentTotal) {
    // If node/clicks has never been set, currentRank will be `null`.
    if (currentTotal) {
      if (total_messages_chat_group < currentTotal) {
        return currentTotal + 1;
      }
      return total_messages_chat_group;
    } else {
      return total_messages_chat_group;
    }
  });
};



/* harmony default export */ __webpack_exports__["b"] = ({
  storeChatGroup: storeChatGroup,
  getChatGroup: getChatGroup,
  storeMessage: storeMessage,
  updateMessage: updateMessage,
  deleteMessage: deleteMessage,
  storeEmployeeChatGroup: storeEmployeeChatGroup,
  updateMessageChatGroup: updateMessageChatGroup,
  updateMessageInstitutions: updateMessageInstitutions,
  getInstitution: getInstitution,
  storeInstitution: storeInstitution
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'institutions';

var show = function show(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/' + id);
};
var get = function get(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('' + resource, { params: params });
};
var search = function search(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/search', { params: params });
};
var employeesSearch = function employeesSearch(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/employees/search', { params: params });
};
var getBookmarks = function getBookmarks(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/bookmarks', { params: params });
};
var getFavorites = function getFavorites(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/favorites', { params: params });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  show: show,
  get: get,
  search: search,
  employeesSearch: employeesSearch,
  getBookmarks: getBookmarks,
  getFavorites: getFavorites
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MESSAGE_TYPE_IMAGE */
/* unused harmony export MESSAGE_TYPE_FILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LINK_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return veevalidate_attributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowedFileTypes; });
var MESSAGE_TYPE_IMAGE = 'image';
var MESSAGE_TYPE_FILE = 'application';
var LINK_BANNER = 'https://www.vitalnet.jp/company/baseball/bcsupport';
var veevalidate_attributes = {
  form_email: 'メールアドレス',
  password: 'パスワード',
  password_confirmation: '（確認用）パスワード'
};

var allowedFileTypes = {
  office: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv'],
  image: ['.png', '.jpg', '.jpeg'],
  document: ['.pdf'],
  movie: ['.mp4', '.mov'],
  other: ['.zip', '.ai']
};

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_init_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f376ccf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_init_vue__ = __webpack_require__(599);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_init_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f376ccf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_init_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_polyfill__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_infinite_loading__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__validate__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_ja__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_ja__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_const__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_outside_events__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_outside_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_outside_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuejs_progress_bar__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuejs_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuejs_progress_bar__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vuejs_progress_bar___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9_axios___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.baseURL = "https://vnfine.net/api/v1";
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.headers.get['Pragma'] = 'no-cache';
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_outside_events___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_ja___default.a });

__WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_ja___default.a.attributes = __WEBPACK_IMPORTED_MODULE_19__config_const__["c" /* veevalidate_attributes */];
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__validate__["a" /* default */], {
  locale: 'ja',
  dictionary: {
    ja: __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_ja___default.a
  }
});

__WEBPACK_IMPORTED_MODULE_16__validate__["a" /* default */].Validator.extend('verify_password', {
  getMessage: function getMessage(field) {
    return '8\u6841\u3001\u82F1\u6570\u5B57\u3001\u5927\u6587\u5B57\u3092\u542B\u3080\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044';
  },
  validate: function validate(value) {
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');
    var onlyAlphanumeric = new RegExp(/^[A-Za-z0-9]+$/);
    return strongRegex.test(value) && onlyAlphanumeric.test(value);
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__webpack_require__(724), {
  auth: __webpack_require__(728),
  http: __webpack_require__(729),
  router: __webpack_require__(730),
  refreshData: { enabled: false },
  tokenDefaultName: 'sns'
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_infinite_loading___default.a);

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_13__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7304e068_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(600);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7304e068_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAArNJREFUWAntl7trFUEUxneTiGDEJz4QNKjE2EUhrUQQERsbmxQWARE70SqF+A8IQQSrgIUg+ChsogiCsQkBHyhYpBCCkPgIYlCDJhqj1993mVkmc2f37kNTeeC7c+abc75zdu++JooCVqvVWsEw+A3KmnJHwMpAiYSK5RG0imFFwkZRF/5jZ17FPUzyU0dgMY7jb3YeU3yIySlLBMYFuE8BPotax2LWkd+iib66AA0sgix7kFUptIbY7SxBs9au3DbQakR+MU4YX913GL/qMIXAvBHZyWj/atWOWsyCho+cli4B/5jDV3VPOLqvfTG3AX9tWeb/G9AZ+GHO9eplOOdujXpdNfDGFG7n9uj8V02gvRntbUZ/hgvzu3w1MGJIDQOO/7ddV/thIk5nu8E8sHYeZ7+dMFZ9EPWicQbY98pP/O6kATkQF4Br75zJ6JLgHBNy7zn5rpbowQYJyDZwWasBm4arv7QaElMI4l8FdERdBenvCBb7wBTwrTelVgNNYrefzFwHcbIhOEQQqG+BA+A6sDaOk965ESJGuU9sEuMdcBDY53+oZJgjaQ34AKwN4aQKsdYCBm0w4yzYFFbPySLQ7wjKfQ6WXsFowe0FY8C1sznLZIehqNvSt5cQN8ENoKZ8u5itWnAV9dPgs18lMP8Kd66gfL5whLeCS2AC+DYJcQVsz6dWMYpC7t9S6XSX/R744hzDrOMXdss2ULhQWkLTRyyneyPJ/aAH7AKyLcB+tL7FF2ST4Bm4xut2WkQlo/hR8B4UtRkSjlct3onIXNHKTvwC/r7STZB83xHTw+YI6GiCQ6yPAmtjzRoIXgNka7Oiq1t7Rpm2Ztqi5TG9LzaYQG121nI9JHtBX6C+O/FJ5juALa7l9fopYTqQPeBFWm7abair+S6opSXm4JX7CIxnxf4B2UCso/naGxMAAAAASUVORK5CYII="

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigator_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81a6084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigator_vue__ = __webpack_require__(566);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81a6084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigator",class:{has_links: _vm.links.length > 0}},[(_vm.links.length > 0)?[_c('div',_vm._l((_vm.links),function(link,index){return _c('span',{key:index,staticClass:"navigator_item",class:{w100: _vm.links.length === 1}},[(link.route)?_c('router-link',{attrs:{"to":link.route}},[_c('span',{staticClass:"icon_arrow"}),_vm._v(" "+_vm._s(link.title)+"\n        ")]):_c('span',[_vm._v(_vm._s(link.title))])],1)}),0),_vm._v(" "),(_vm.fineplay && _vm.links.length > 1 && _vm.canApplyFinePlay())?_c('span',{staticClass:"btn_fineplay",on:{"click":_vm.handleToggleFineplayScreenChat}},[_c('img',{attrs:{"src":__webpack_require__(559),"alt":""}})]):_vm._e()]:[_c('span',{staticClass:"menu_button",on:{"click":_vm.toggleMenu}},[(_vm.numberUnReadFineplayApprove)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMenu),expression:"!showMenu"}],staticClass:"badge"},[_vm._v(_vm._s(_vm.numberUnReadFineplayApprove))]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMenu),expression:"showMenu"}],staticClass:"menus"},[_c('div',{staticClass:"item sns",on:{"click":function($event){return _vm.goTo('home')}}},[_c('span',{staticClass:"icon"}),_vm._v(" チャット\n      ")]),_vm._v(" "),_c('div',{staticClass:"item share",on:{"click":function($event){return _vm.goTo('shares')}}},[_c('span',{staticClass:"icon"}),_vm._v(" シェア\n      ")]),_vm._v(" "),_c('div',{staticClass:"item fine_play",on:{"click":function($event){return _vm.goTo('finePlays')}}},[_c('span',{staticClass:"icon"}),_vm._v(" ファインプレー\n      ")]),_vm._v(" "),(_vm.canApproveFinePlay)?_c('div',{staticClass:"item fine_play_approve",on:{"click":function($event){return _vm.goTo('finePlayApproves')}}},[_c('span',{staticClass:"icon"}),_vm._v(" 未承認\n        "),(_vm.numberUnReadFineplayApprove)?_c('span',{staticClass:"badge_item"},[_vm._v(_vm._s(_vm.numberUnReadFineplayApprove))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canShowSurvey)?_c('div',{staticClass:"item survey",on:{"click":function($event){return _vm.goTo('surveys.index')}}},[_c('span',{staticClass:"icon"}),_vm._v(" アンケート\n        "),(_vm.numberSurveyNotComplete)?_c('span',{staticClass:"badge_item"},[_vm._v(_vm._s(_vm.numberSurveyNotComplete))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item profile",on:{"click":function($event){return _vm.goTo('profile')}}},[_c('span',{staticClass:"icon"}),_vm._v(" 設定\n      ")]),_vm._v(" "),_c('div',{staticClass:"item logout",on:{"click":_vm.logout}},[_c('span',{staticClass:"icon"}),_vm._v(" ログアウト\n      ")])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{logged_in: _vm.$auth.check()},attrs:{"id":"app"}},[(_vm.env === 'staging')?_c('div',{staticClass:"env"},[_vm._v("FINEテスト環境")]):_vm._e(),_vm._v(" "),(_vm.$auth.check())?_c('Navigator'):_vm._e(),_vm._v(" "),(_vm.$auth.check())?_c('Init'):_vm._e(),_vm._v(" "),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_index__ = __webpack_require__(108);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },

  routes: [{
    path: '/',
    name: 'home',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 733));
    },
    meta: { auth: true, title: 'SNS' }
  }, {
    path: '/institutions/search',
    name: 'institutions.search',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 734));
    },
    meta: { auth: true }
  }, {
    path: '/institutions/:institutionCode',
    name: 'institutions.show',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 735));
    },
    meta: { auth: true }
  }, {
    path: '/chat-groups/:chatGroupId/chat',
    name: 'chat',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 736));
    },
    meta: { auth: true }
  }, {
    path: '/fine-plays',
    name: 'finePlays',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 737));
    },
    meta: { auth: true }
  }, {
    path: '/fine-plays/:finePlayId',
    name: 'finePlays.show',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 738));
    },
    meta: { auth: true }
  }, {
    path: '/fine-plays-approve',
    name: 'finePlayApproves',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 739));
    },
    meta: { auth: [__WEBPACK_IMPORTED_MODULE_2__config_index__["j" /* MS_AUTHORITY_HEAD_OF_DEPARTMENT */], __WEBPACK_IMPORTED_MODULE_2__config_index__["i" /* MS_AUTHORITY_HEAD_OF_BRANCH */], __WEBPACK_IMPORTED_MODULE_2__config_index__["k" /* MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT */], __WEBPACK_IMPORTED_MODULE_2__config_index__["h" /* MS_AUTHORITY_HEADQUARTERS */]] }
  }, {
    path: '/fine-plays-approve/:finePlayId',
    name: 'finePlayApproves.show',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 740));
    },
    meta: { auth: [__WEBPACK_IMPORTED_MODULE_2__config_index__["j" /* MS_AUTHORITY_HEAD_OF_DEPARTMENT */], __WEBPACK_IMPORTED_MODULE_2__config_index__["i" /* MS_AUTHORITY_HEAD_OF_BRANCH */], __WEBPACK_IMPORTED_MODULE_2__config_index__["k" /* MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT */], __WEBPACK_IMPORTED_MODULE_2__config_index__["h" /* MS_AUTHORITY_HEADQUARTERS */]] }
  }, {
    path: '/shares',
    name: 'shares',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 741));
    },
    meta: { auth: true }
  }, {
    path: '/shares/:institutionCode',
    name: 'shares.show',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 742));
    },
    meta: { auth: true }
  }, {
    path: '/shares/:chatGroupId/chat/:messageId',
    name: 'shares.chat',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 743));
    },
    meta: { auth: true }
  }, {
    path: '/bookmarks/:chatGroupId/:messageId',
    name: 'bookmarks.show',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 744));
    },
    meta: { auth: true }
  }, {
    path: '/surveys',
    name: 'surveys.index',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 745));
    },
    meta: { auth: true }
  }, {
    path: '/surveys/:id',
    name: 'surveys.show',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 746));
    },
    meta: { auth: true }
  }, {
    path: '/login',
    name: 'login',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 747));
    },
    meta: { auth: false }
  }, {
    path: '/forgot-password',
    name: 'forgot-password',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 748));
    },
    meta: { auth: false }
  }, {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 749));
    },
    meta: { auth: false }
  }, {
    path: '/profile',
    name: 'profile',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 750));
    },
    meta: { auth: true, title: '設定' }
  }, {
    path: '/term-of-use',
    name: 'term-of-use',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 751));
    },
    meta: { auth: false }
  }, {
    path: '/403',
    name: '403',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 752));
    },
    meta: { title: '403' }
  }]
}));

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 222,
	"./af.js": 222,
	"./ar": 223,
	"./ar-dz": 224,
	"./ar-dz.js": 224,
	"./ar-kw": 225,
	"./ar-kw.js": 225,
	"./ar-ly": 226,
	"./ar-ly.js": 226,
	"./ar-ma": 227,
	"./ar-ma.js": 227,
	"./ar-sa": 228,
	"./ar-sa.js": 228,
	"./ar-tn": 229,
	"./ar-tn.js": 229,
	"./ar.js": 223,
	"./az": 230,
	"./az.js": 230,
	"./be": 231,
	"./be.js": 231,
	"./bg": 232,
	"./bg.js": 232,
	"./bm": 233,
	"./bm.js": 233,
	"./bn": 234,
	"./bn.js": 234,
	"./bo": 235,
	"./bo.js": 235,
	"./br": 236,
	"./br.js": 236,
	"./bs": 237,
	"./bs.js": 237,
	"./ca": 238,
	"./ca.js": 238,
	"./cs": 239,
	"./cs.js": 239,
	"./cv": 240,
	"./cv.js": 240,
	"./cy": 241,
	"./cy.js": 241,
	"./da": 242,
	"./da.js": 242,
	"./de": 243,
	"./de-at": 244,
	"./de-at.js": 244,
	"./de-ch": 245,
	"./de-ch.js": 245,
	"./de.js": 243,
	"./dv": 246,
	"./dv.js": 246,
	"./el": 247,
	"./el.js": 247,
	"./en-SG": 248,
	"./en-SG.js": 248,
	"./en-au": 249,
	"./en-au.js": 249,
	"./en-ca": 250,
	"./en-ca.js": 250,
	"./en-gb": 251,
	"./en-gb.js": 251,
	"./en-ie": 252,
	"./en-ie.js": 252,
	"./en-il": 253,
	"./en-il.js": 253,
	"./en-nz": 254,
	"./en-nz.js": 254,
	"./eo": 255,
	"./eo.js": 255,
	"./es": 256,
	"./es-do": 257,
	"./es-do.js": 257,
	"./es-us": 258,
	"./es-us.js": 258,
	"./es.js": 256,
	"./et": 259,
	"./et.js": 259,
	"./eu": 260,
	"./eu.js": 260,
	"./fa": 261,
	"./fa.js": 261,
	"./fi": 262,
	"./fi.js": 262,
	"./fo": 263,
	"./fo.js": 263,
	"./fr": 264,
	"./fr-ca": 265,
	"./fr-ca.js": 265,
	"./fr-ch": 266,
	"./fr-ch.js": 266,
	"./fr.js": 264,
	"./fy": 267,
	"./fy.js": 267,
	"./ga": 268,
	"./ga.js": 268,
	"./gd": 269,
	"./gd.js": 269,
	"./gl": 270,
	"./gl.js": 270,
	"./gom-latn": 271,
	"./gom-latn.js": 271,
	"./gu": 272,
	"./gu.js": 272,
	"./he": 273,
	"./he.js": 273,
	"./hi": 274,
	"./hi.js": 274,
	"./hr": 275,
	"./hr.js": 275,
	"./hu": 276,
	"./hu.js": 276,
	"./hy-am": 277,
	"./hy-am.js": 277,
	"./id": 278,
	"./id.js": 278,
	"./is": 279,
	"./is.js": 279,
	"./it": 280,
	"./it-ch": 281,
	"./it-ch.js": 281,
	"./it.js": 280,
	"./ja": 282,
	"./ja.js": 282,
	"./jv": 283,
	"./jv.js": 283,
	"./ka": 284,
	"./ka.js": 284,
	"./kk": 285,
	"./kk.js": 285,
	"./km": 286,
	"./km.js": 286,
	"./kn": 287,
	"./kn.js": 287,
	"./ko": 288,
	"./ko.js": 288,
	"./ku": 289,
	"./ku.js": 289,
	"./ky": 290,
	"./ky.js": 290,
	"./lb": 291,
	"./lb.js": 291,
	"./lo": 292,
	"./lo.js": 292,
	"./lt": 293,
	"./lt.js": 293,
	"./lv": 294,
	"./lv.js": 294,
	"./me": 295,
	"./me.js": 295,
	"./mi": 296,
	"./mi.js": 296,
	"./mk": 297,
	"./mk.js": 297,
	"./ml": 298,
	"./ml.js": 298,
	"./mn": 299,
	"./mn.js": 299,
	"./mr": 300,
	"./mr.js": 300,
	"./ms": 301,
	"./ms-my": 302,
	"./ms-my.js": 302,
	"./ms.js": 301,
	"./mt": 303,
	"./mt.js": 303,
	"./my": 304,
	"./my.js": 304,
	"./nb": 305,
	"./nb.js": 305,
	"./ne": 306,
	"./ne.js": 306,
	"./nl": 307,
	"./nl-be": 308,
	"./nl-be.js": 308,
	"./nl.js": 307,
	"./nn": 309,
	"./nn.js": 309,
	"./pa-in": 310,
	"./pa-in.js": 310,
	"./pl": 311,
	"./pl.js": 311,
	"./pt": 312,
	"./pt-br": 313,
	"./pt-br.js": 313,
	"./pt.js": 312,
	"./ro": 314,
	"./ro.js": 314,
	"./ru": 315,
	"./ru.js": 315,
	"./sd": 316,
	"./sd.js": 316,
	"./se": 317,
	"./se.js": 317,
	"./si": 318,
	"./si.js": 318,
	"./sk": 319,
	"./sk.js": 319,
	"./sl": 320,
	"./sl.js": 320,
	"./sq": 321,
	"./sq.js": 321,
	"./sr": 322,
	"./sr-cyrl": 323,
	"./sr-cyrl.js": 323,
	"./sr.js": 322,
	"./ss": 324,
	"./ss.js": 324,
	"./sv": 325,
	"./sv.js": 325,
	"./sw": 326,
	"./sw.js": 326,
	"./ta": 327,
	"./ta.js": 327,
	"./te": 328,
	"./te.js": 328,
	"./tet": 329,
	"./tet.js": 329,
	"./tg": 330,
	"./tg.js": 330,
	"./th": 331,
	"./th.js": 331,
	"./tl-ph": 332,
	"./tl-ph.js": 332,
	"./tlh": 333,
	"./tlh.js": 333,
	"./tr": 334,
	"./tr.js": 334,
	"./tzl": 335,
	"./tzl.js": 335,
	"./tzm": 336,
	"./tzm-latn": 337,
	"./tzm-latn.js": 337,
	"./tzm.js": 336,
	"./ug-cn": 338,
	"./ug-cn.js": 338,
	"./uk": 339,
	"./uk.js": 339,
	"./ur": 340,
	"./ur.js": 340,
	"./uz": 341,
	"./uz-latn": 342,
	"./uz-latn.js": 342,
	"./uz.js": 341,
	"./vi": 343,
	"./vi.js": 343,
	"./x-pseudo": 344,
	"./x-pseudo.js": 344,
	"./yo": 345,
	"./yo.js": 345,
	"./zh-cn": 346,
	"./zh-cn.js": 346,
	"./zh-hk": 347,
	"./zh-hk.js": 347,
	"./zh-tw": 348,
	"./zh-tw.js": 348
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_navigator__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_institution__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_masterData__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_surveys__ = __webpack_require__(649);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    navigator: __WEBPACK_IMPORTED_MODULE_2__modules_navigator__["a" /* default */],
    institution: __WEBPACK_IMPORTED_MODULE_3__modules_institution__["a" /* default */],
    masterData: __WEBPACK_IMPORTED_MODULE_4__modules_masterData__["a" /* default */],
    surveys: __WEBPACK_IMPORTED_MODULE_5__modules_surveys__["a" /* default */]
  }
}));

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(636);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true, state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */], mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(349);


var setTitle = function setTitle(_ref, title) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_NAVIGATOR_TITLE */], title);
};

var setLinks = function setLinks(_ref2, links) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SET_NAVIGATOR_LINKS */], links);
};

var setFineplay = function setFineplay(_ref3, fineplay) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_STATUS_FINEPLAY */], fineplay);
};

var toogleFineplayScreenChat = function toogleFineplayScreenChat(_ref4, enableFineplay) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* TOOGLE_FINEPLAY_SCREEN_CHAT */], enableFineplay);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setTitle: setTitle,
  setLinks: setLinks,
  setFineplay: setFineplay,
  toogleFineplayScreenChat: toogleFineplayScreenChat
});

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var title = function title(state) {
  return state.title;
};
var links = function links(state) {
  return state.links;
};
var fineplay = function fineplay(state) {
  return state.fineplay;
};
var enableFineplay = function enableFineplay(state) {
  return state.enableFineplay;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  title: title,
  links: links,
  fineplay: fineplay,
  enableFineplay: enableFineplay
});

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(349);


var _types$SET_NAVIGATOR_;



/* harmony default export */ __webpack_exports__["a"] = (_types$SET_NAVIGATOR_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NAVIGATOR_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_NAVIGATOR_TITLE */], function (state, title) {
  state.title = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NAVIGATOR_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_NAVIGATOR_LINKS */], function (state, links) {
  state.links = links;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NAVIGATOR_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_STATUS_FINEPLAY */], function (state, fineplay) {
  state.fineplay = fineplay;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NAVIGATOR_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOOGLE_FINEPLAY_SCREEN_CHAT */], function (state) {
  var enableFineplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  state.enableFineplay = enableFineplay === null ? !state.enableFineplay : enableFineplay;
}), _types$SET_NAVIGATOR_);

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: '',
  links: [],
  fineplay: false,
  enableFineplay: false
});

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(641);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true, state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */], mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_institution__ = __webpack_require__(368);



var _this = this;




var getInstitutions = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, _ref3) {
    var commit = _ref2.commit;
    var params = _ref3.params,
        state = _ref3.state;
    var res, institutions, meta;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__api_institution__["a" /* default */].get(params);

          case 2:
            res = _context.sent;
            institutions = res.data.data;
            meta = res.data.meta;

            if (institutions.length > 0) {
              state.loaded();
              commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_INSTITUTIONS */], institutions);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_INSTITUTIONS_META */], meta);
            } else {
              state.complete();
            }

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getInstitutions(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getGroups = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, _ref6) {
    var commit = _ref5.commit;
    var offset = _ref6.offset,
        state = _ref6.state;
    var res, groups;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__api_institution__["a" /* default */].get({ offset: offset });

          case 2:
            res = _context2.sent;
            groups = res.data.data;

            if (groups.length > 0) {
              state.loaded();
              commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_GROUPS */], groups);
            } else {
              state.complete();
            }

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getGroups(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

var searchInstitutions = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, _ref9) {
    var commit = _ref8.commit;
    var params = _ref9.params;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__api_institution__["a" /* default */].get(params);

          case 2:
            res = _context3.sent;
            return _context3.abrupt('return', res);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function searchInstitutions(_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();

var showGroupChildren = function showGroupChildren(_ref10, employeeCode) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_GROUP_SELECTED */], employeeCode);
};

var clearUnreadMessages = function clearUnreadMessages(_ref11, payload) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CLEAR_UNREAD_MESSAGES */], payload);
};

var setCurrentPos = function setCurrentPos(_ref12, pos) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_CURRENT_POST */], pos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInstitutions: getInstitutions,
  searchInstitutions: searchInstitutions,
  getGroups: getGroups,
  showGroupChildren: showGroupChildren,
  clearUnreadMessages: clearUnreadMessages,
  setCurrentPos: setCurrentPos
});

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var institutions = function institutions(state) {
  return state.institutions;
};
var institutionsMeta = function institutionsMeta(state) {
  return state.institutionsMeta;
};
var groups = function groups(state) {
  return state.groups;
};
var groupEmployeeSelected = function groupEmployeeSelected(state) {
  return state.groupEmployeeSelected;
};
var currentPos = function currentPos(state) {
  return state.currentPos;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  institutions: institutions,
  institutionsMeta: institutionsMeta,
  groups: groups,
  groupEmployeeSelected: groupEmployeeSelected,
  currentPos: currentPos
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);



var _types$SET_INSTITUTIO;




/* harmony default export */ __webpack_exports__["a"] = (_types$SET_INSTITUTIO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_INSTITUTIONS */], function (state, institutions) {
  state.institutions = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.institutions), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(institutions));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_INSTITUTIONS_META */], function (state, meta) {
  state.institutionsMeta = meta;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_GROUPS */], function (state, groups) {
  state.groups = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.groups), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(groups));
  state.groups = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(state.groups, 'employee_code');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_GROUP_SELECTED */], function (state, employeeCode) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.groupEmployeeSelected, function (n) {
    return n === employeeCode;
  }) > -1) {
    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(state.groupEmployeeSelected, function (n) {
      return n === employeeCode;
    });
  } else {
    state.groupEmployeeSelected.push(employeeCode);
  }
  state.groupEmployeeSelected = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.groupEmployeeSelected));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CLEAR_UNREAD_MESSAGES */], function (state, payload) {
  var groupIndex = -1;
  var institutionIndex = -1;
  __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(state.groups, function (n, index) {
    groupIndex = index;
    institutionIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.groups[index].institutions, function (n) {
      return n.institution_code === payload.institutionCode;
    });
    if (institutionIndex > -1) return false;
  });
  if (institutionIndex > -1) {
    state.groups[groupIndex].institutions[institutionIndex].total_unread_messages -= payload.total;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_INSTITUTIO, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_CURRENT_POST */], function (state, pos) {
  state.currentPos = pos;
}), _types$SET_INSTITUTIO);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  institutions: [],
  institutionsMeta: {},
  groups: [],
  groupEmployeeSelected: [],
  currentPos: 0
});

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(648);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true, state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */], mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_ng_word__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_questionnaire__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_notification__ = __webpack_require__(645);



var _this = this;

/* eslint-disable */






var getNGWords = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__api_ng_word__["a" /* default */].get();

          case 2:
            res = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_NG_WORDS */], res.data.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getNGWords(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getUnreadFineplayApprove = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__["a" /* default */].get({ active: false });

          case 2:
            res = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* SET_UNREAD_FINEPLAY_APPROVE */], res.data.data);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getUnreadFineplayApprove(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var getNotifications = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
    var commit = _ref6.commit;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_6__api_notification__["a" /* default */].get();

          case 2:
            res = _context3.sent;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_NOTIFICATIONS */], res.data.data);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getNotifications(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var addNGWord = function addNGWord(_ref7, ngWord) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ADD_NGWORD */], ngWord);
};
var updateNGWord = function updateNGWord(_ref8, ngWord) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* UPDATE_NGWORD */], ngWord);
};
var deleteNGWord = function deleteNGWord(_ref9, ngWord) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* DELETE_NGWORD */], ngWord);
};
var getNumberSurveyNotComplete = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11) {
    var commit = _ref11.commit;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5__api_questionnaire__["a" /* default */].count();

          case 2:
            res = _context4.sent;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_TOTAL_NOT_COMPLETE_SURVEY */], res.data);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function getNumberSurveyNotComplete(_x4) {
    return _ref10.apply(this, arguments);
  };
}();
var completeSurvey = function completeSurvey(_ref12) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* COMPLETE_SURVEY */]);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getNGWords: getNGWords,
  getUnreadFineplayApprove: getUnreadFineplayApprove,
  getNotifications: getNotifications,
  addNGWord: addNGWord,
  updateNGWord: updateNGWord,
  deleteNGWord: deleteNGWord,
  getNumberSurveyNotComplete: getNumberSurveyNotComplete,
  completeSurvey: completeSurvey
});

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var get = function get() {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('master-data/ng-words');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get
});

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var get = function get() {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('master-data/notifications');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get
});

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ngWords = function ngWords(state) {
  return state.ngWords;
};
var numberUnReadFineplayApprove = function numberUnReadFineplayApprove(state) {
  return state.numberUnReadFineplayApprove;
};
var notifications = function notifications(state) {
  return state.notifications;
};
var numberSurveyNotComplete = function numberSurveyNotComplete(state) {
  return state.numberSurveyNotComplete;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  ngWords: ngWords,
  numberUnReadFineplayApprove: numberUnReadFineplayApprove,
  notifications: notifications,
  numberSurveyNotComplete: numberSurveyNotComplete
});

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(351);



var _types$SET_NG_WORDS$t;

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = (_types$SET_NG_WORDS$t = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_NG_WORDS */], function (state, words) {
  state.ngWords = words;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* SET_UNREAD_FINEPLAY_APPROVE */], function (state, fineplays) {
  var count = 0;
  fineplays.map(function (fineplay) {
    if (fineplay.can_approve) count++;
  });
  state.numberUnReadFineplayApprove = count;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_NOTIFICATIONS */], function (state, notifications) {
  state.notifications = notifications;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ADD_NGWORD */], function (state, ngWord) {
  state.ngWords = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.ngWords), [ngWord]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* UPDATE_NGWORD */], function (state, ngWord) {
  var index = state.ngWords.findIndex(function (n) {
    return n.id === ngWord.id;
  });
  if (index !== -1) {
    state.ngWords[index] = ngWord;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* DELETE_NGWORD */], function (state, ngWord) {
  var index = state.ngWords.findIndex(function (n) {
    return n.id === ngWord.id;
  });
  if (index !== -1) {
    state.ngWords.splice(index);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_TOTAL_NOT_COMPLETE_SURVEY */], function (state, count) {
  state.numberSurveyNotComplete = count.total_not_complete;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_NG_WORDS$t, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* COMPLETE_SURVEY */], function (state) {
  if (state.numberSurveyNotComplete) {
    state.numberSurveyNotComplete = state.numberSurveyNotComplete - 1;
  }
}), _types$SET_NG_WORDS$t);

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ngWords: [],
  numberUnReadFineplayApprove: 0,
  notifications: [],
  numberSurveyNotComplete: 0
});

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(653);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true, state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */], mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_questionnaire__ = __webpack_require__(159);



var _this = this;




var getSurveys = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, params) {
    var commit = _ref2.commit;
    var res, surveys;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__api_questionnaire__["a" /* default */].get(params);

          case 2:
            res = _context.sent;
            surveys = res.data.data;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_SURVEYS */], surveys);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getSurveys(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var deleteSurvey = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, survey) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* DELETE_SURVEY */], survey);

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function deleteSurvey(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
var setIsShowSurveysModal = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, status) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_IS_SHOW_SURVEYS_MODAL */], status);

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function setIsShowSurveysModal(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

var setIsShowSurveyToLocalStorage = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE */]);

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function setIsShowSurveyToLocalStorage(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  getSurveys: getSurveys,
  deleteSurvey: deleteSurvey,
  setIsShowSurveysModal: setIsShowSurveysModal,
  setIsShowSurveyToLocalStorage: setIsShowSurveyToLocalStorage
});

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var surveys = function surveys(state) {
  return state.surveys;
};
var isShowSurveysModal = function isShowSurveysModal(state) {
  return state.isShowSurveysModal;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  surveys: surveys,
  isShowSurveysModal: isShowSurveysModal
});

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(352);



var _types$SET_SURVEYS$ty;



/* harmony default export */ __webpack_exports__["a"] = (_types$SET_SURVEYS$ty = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SURVEYS$ty, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_SURVEYS */], function (state, surveys) {
  state.surveys = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(surveys));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SURVEYS$ty, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* DELETE_SURVEY */], function (state, survey) {
  var index = state.surveys.findIndex(function (n) {
    return n.id === survey.id;
  });
  state.surveys[index] = survey;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SURVEYS$ty, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_IS_SHOW_SURVEYS_MODAL */], function (state, status) {
  state.isShowSurveysModal = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SURVEYS$ty, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE */], function (state) {
  state.isShowSurveysModal = true;
}), _types$SET_SURVEYS$ty);

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  surveys: [],
  isShowSurveysModal: false
});

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["dateTimeFormat"] = dateTimeFormat;
/* harmony export (immutable) */ __webpack_exports__["dateFormat"] = dateFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function dateTimeFormat(timestamp) {
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(timestamp);
  if (date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), 'day')) return date.format('HH:mm');
  if (date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), 'year')) return date.format('MM/DD HH:mm');
  return date.format('YYYY/MM/DD HH:mm');
}

function dateFormat(timestamp) {
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(timestamp);
  return date.format('YYYY/MM/DD');
}

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var rq = {
  get: function get(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(resource, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { headers: { Pragma: 'no-cache', 'Cache-Control': 'no-cache, no-store' } }));
  },
  post: function post(resource, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(resource, data);
  },
  put: function put(resource, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(resource, data);
  },
  delete: function _delete(resource) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(resource);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (rq);

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(719);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* default */]);

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

/* eslint-disable */
module.exports = {

    request: function request(req, token) {
        this.options.http._setHeaders.call(this, req, { JWTAuthorization: 'Bearer ' + token });
    },

    response: function response(res) {
        var headers = this.options.http._getHeaders.call(this, res),
            token = headers.Authorization || headers.authorization;

        if (token) {
            token = token.split(/Bearer\:?\s?/i);

            return token[token.length > 1 ? 1 : 0].trim();
        }
    }
};

/***/ })

},[371]);


// WEBPACK FOOTER //
// static/js/app.a0a38f958c737b9aa510.js